import LegalDocView from '../components/LegalDocView'
import { useSeoHead } from '../lib/seo'

export default function TermsPage() {
  useSeoHead({
    title: 'Obchodní podmínky | SEO Tools',
    description: 'Obchodní podmínky služby SEO Tools — práva a povinnosti, platby a předplatné, odstoupení od smlouvy a reklamace.',
    canonicalPath: '/obchodni-podminky',
  })
  return <LegalDocView doc="terms" />
}
